import { APP_EED } from '@/features/app-eed/container/app.builder';
import { APPS } from '@/features/core/container';
import { GroupRole } from '@/types/iot-portal';
import { option } from '@/util/container';
import icon from '../assets/app-suite-five.svg?vue';

export const APP_SUITE_FIVE = GroupRole.APP_SUITE_FIVE;

export default option(APPS, async () => {
  return {
    name: APP_SUITE_FIVE,
    label: 'Suite5',
    link: {
      to: { name: 'AppSuiteFive' },
      icon,
    },
    hiddenForApps: [APP_EED],
    order: -1,
  };
});
